"use client";

import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { WorkspaceFile } from "@/lib/workspace-context";

interface EditorBreadcrumbProps {
  file: WorkspaceFile;
  className?: string;
}

/**
 * Breadcrumb interno del editor: muestra Inicio > carpeta padre > archivo actual.
 * El último segmento no es clickeable.
 */
export function EditorBreadcrumb({ file, className }: EditorBreadcrumbProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-1 text-[11px] font-medium text-muted-foreground",
        className,
      )}
    >
      <span className="truncate max-w-[80px]">Inicio</span>
      {file.parentId && (
        <>
          <ChevronRight className="w-3 h-3 opacity-40 shrink-0" aria-hidden="true" />
          <span className="truncate max-w-[80px]">…</span>
        </>
      )}
      <ChevronRight className="w-3 h-3 opacity-40 shrink-0" aria-hidden="true" />
      <span
        className="text-foreground font-semibold truncate"
        title={file.name.replace(".md", "")}
      >
        {file.name.replace(".md", "")}
      </span>
    </div>
  );
}
